import { render, staticRenderFns } from "./read.vue?vue&type=template&id=6809866f&scoped=true"
import script from "./read.vue?vue&type=script&lang=ts"
export * from "./read.vue?vue&type=script&lang=ts"
import style0 from "./read.vue?vue&type=style&index=0&id=6809866f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809866f",
  null
  
)

export default component.exports